import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import '../Styles/Home.css'
import {Grid, useMediaQuery} from "@mui/material";
import HomeCardContent from "../Components/HomeCardContent";

export default function Home() {
    if (useMediaQuery('(max-width:1100px)'))
        return (

            <Card className={'mainCard'}>
                <CardMedia
                    component="img"
                    image="Images/Altenberg/GroupPhoto.jpg"
                    alt="GroupPhoto"
                />
                <CardContent>
                    <HomeCardContent/>
                </CardContent>
            </Card>
        )
    return (
        <>
                <Card className={'mainCard'} sx={{display: 'flex'}} direction="row">
                <Grid container alignItems="flex-start">
                    <Grid item sm={5} md={6} lg={5.5}>
                        <CardMedia
                            component="img"
                            image="Images/Altenberg/poster2.png"
                            alt="Altenberg Poster"
                        />
                    </Grid>
                    <Grid item sm={7} md={6} lg={6.5}>
                        <CardContent sx={{ pb: 0, '&:last-child': { pb: .5 },}}>
                            <HomeCardContent/>
                        </CardContent>
                    </Grid>
                </Grid>
            </Card>

        </>
    )
}